import { render, staticRenderFns } from "./Caixa.vue?vue&type=template&id=aa4340d0&scoped=true&"
import script from "./caixa.js?vue&type=script&lang=js&"
export * from "./caixa.js?vue&type=script&lang=js&"
import style0 from "./Caixa.vue?vue&type=style&index=0&id=aa4340d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4340d0",
  null
  
)

export default component.exports